// extracted by mini-css-extract-plugin
module.exports = {"versionMessageContainer":"DocumentVersionMessage_versionMessageContainer__3ak3p","closeVersion":"DocumentVersionMessage_closeVersion__jO2Ml"};